import { EmailField } from '@/domain/mitarbeiter/features/anlageassistent/components/EmailField';
import { PersonalfragebogenField } from '@/domain/mitarbeiter/features/anlageassistent/components/MitarbeiterSpeicheroptionen/Fields/PersonalfragebogenField';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Checkbox, Label } from '@e2n/ui';
import { useTranslation } from 'react-i18next';

export function PersonalzugangField() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();
  return (
    <form.AppField
      name="speicheroptionen.personalzugang"
      listeners={{
        onChange: () => {
          ctx.resetDependentFields('speicheroptionen.personalzugang');
        },
      }}>
      {(field) => (
        <div className="flex gap-2 items-start">
          <Checkbox
            id={field.name}
            name={field.name}
            checked={field.state.value}
            onCheckedChange={(e) => field.handleChange(!!e)}
            onBlur={field.handleBlur}
          />
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <Label
                htmlFor={field.name}
                className="text-neutrals-900 text-sm font-normal leading-5 w-fit">
                {t(
                  'domain.mitarbeiter.create.speicheroptionen.dialog.app_fragebogen.personalzugang.label',
                )}
              </Label>
              <span className="text-neutrals-800 text-sm font-normal leading-5">
                {t(
                  'domain.mitarbeiter.create.speicheroptionen.dialog.app_fragebogen.personalzugang.description',
                )}
              </span>
              {field.state.value && <EmailField />}
            </div>

            <PersonalfragebogenField />
          </div>
        </div>
      )}
    </form.AppField>
  );
}
